export default __webpack_public_path__ + "static/media/analysis.5a794e04.png";